<template>
  <div class="foot" ref="element">
    <div class="footer-bottm">
      <div class="footer-bottm-w">
        <div class="medium">
          <!-- <span>Follow us</span> -->
          <a href="https://medium.com/@transformerschain" target="_blank">
            <img src="@/assets/m/home/footer1.png"
          /></a>
          <a href="https://twitter.com/TFSCChain" target="_blank">
            <img src="@/assets/m/home/footer2.png"
          /></a>
          <a href="https://t.me/transformerschain" target="_blank">
            <img src="@/assets/m/home/footer3.png"
          /></a>
          <a
            href="https://www.youtube.com/channel/UCxkH0sBwC9cASd3c3qwyvmA"
            target="_blank"
          >
            <img src="@/assets/m/home/footer4.png"
          /></a>
          <a href="https://discord.com/invite/W4YsQduNrf" target="_blank">
            <img src="@/assets/m/home/footer5.png"
          /></a>
          <a href="#">
            <img src="@/assets/m/home/footer6.png" />
          </a>
        </div>
        <p>©2024 - Transformers, Inc.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.foot {
  margin: 0px;
  padding: 0px;
  position: relative;
  // border: 1px solid red;
  left: 0;
  bottom: 0;
  width: 750px;
  height: 210px;
  background: #13161b;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  /*margin-top:119px;*/
  text-align: center;
  p {
    margin: 0 auto;
    font-size: 28px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.6);
    line-height: 39px;
    padding-top: 33px;
    text-align: center;
  }
  .medium {
    padding-top: 44px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      width: 164px;
      height: 22px;
      display: block;
    }
    img {
      width: 60px;
      height: 60px;
      margin-left: 35px;
    }
  }
}
</style>
